"use client"
import { Link } from "react-router-dom"
import { useTranslations } from "../../../translations"

const Words = ({ currentItems, handleImage, itemOffset, isModule }) => {
  const { t } = useTranslations()

  if (currentItems.length <= 0) {
    return (
      <tr>
        <td colSpan={10} className="text-center py-5 text-muted italic">
          {t("noWords")}
        </td>
      </tr>
    )
  }
  return currentItems.map((word, index) => {
    return (
      <tr key={index} className="align-middle">
        <td className="text-center fw-bold color-plum opacity-50">{index + 1 + itemOffset}</td>
        <td><span className="fw-medium color-plum">{word.spanishName}</span></td>
        <td className="text-center"><span className="badge rounded-pill bg-light text-dark border px-2">{word.spanishBreakUp}</span></td>
        <td>{word.englishName}</td>
        {isModule !== "family" && <td><span className="text-muted small text-uppercase fw-bold">{word.tema}</span></td>}
        {isModule === "received" && <td>{word.sender}</td>}
        {isModule === "sent" && <td>{word.sentTo}</td>}
        <td className="text-center">
          <button
            onClick={() => handleImage(word.imagePath, word.spanishName, word.spanishSound)}
            className="btn-3 py-1 px-3 small shadow-sm"
          >
            {t("view")}
          </button>
        </td>
      </tr>
    )
  })
}

export default Words
